import { OptionModel } from '../model/componentModels'

export const selectOptionFormat = (options: Array<OptionModel>, t: Function, keyHeader: string) => {
  return options.filter(option => option.active).map(option => {
    return { label: t(keyHeader + '.' + option.label), value: option.value }
  })
}
